<script>
  import { onMount } from 'svelte';
  import { createScene, renderer } from "./perlinProd";
  // import { saveAs } from 'file-saver';
  let el;
  
  onMount(() => {
    createScene(el)
  });

  // let saveId = 0
  // window.addEventListener('click', () => {
  //   download()

  // })

  // // @todo => cfr. https://stackoverflow.com/questions/15558418/how-do-you-save-an-image-from-a-three-js-canvas
  // // pour virer preserveDrawingBuffer: true dans perlinXXX.js qui doit ralentir, empeche d'etre à full fps
  // // + faire du svelte...
  // function download() {
  //   var link = document.createElement('a');
  //   link.download = 'filename.png';
  //   renderer.domElement.toDataURL();
  //   link.href = el.toDataURL()
  //   link.click();
  // }
  

</script>

<canvas bind:this={el}></canvas>
